"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

require("core-js/modules/esnext.string.replace-all.js");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _axios = _interopRequireDefault(require("axios"));

var _lodash = require("lodash");

var _antd = require("antd");

var _reactErrorBoundary = require("react-error-boundary");

var _Seo = _interopRequireDefault(require("../Seo"));

var _ErrorFallback = _interopRequireDefault(require("../ErrorFallback"));

var _useForceUpdate = _interopRequireDefault(require("../../hooks/useForceUpdate"));

var _utils = require("../../utils");

var _redux = require("../../redux");

var _templateObject;

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");

  return typeof key === "symbol" ? key : String(key);
}

function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];

  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }

  return (hint === "string" ? String : Number)(input);
} // We need to store the template ID in a global variable to detect template changes.
// Using useEffect doesn't work, because a template switch will immediately render the new component with wrong props which most likely leads to an JS error.


var globalTemplateID = '';

var Editor = function Editor(props) {
  var _editorSite$languages, _post$translations;

  var fields = props.fields,
      postID = props.postID,
      _props$pageContext = props.pageContext,
      themeOptions = _props$pageContext.themeOptions,
      siteTitle = _props$pageContext.siteTitle,
      defaultComponent = props.defaultComponent,
      sidebarOptions = props.sidebarOptions,
      rest = (0, _objectWithoutProperties2.default)(props, ["fields", "postID", "pageContext", "defaultComponent", "sidebarOptions"]);

  var _ref4 = (0, _redux.useAppSelector)(function (state) {
    return state;
  }),
      _ref4$cms = _ref4.cms,
      config = _ref4$cms.config,
      site = _ref4$cms.site,
      siteLoaded = _ref4$cms.siteLoaded,
      _ref4$cms$editor = _ref4$cms.editor,
      editorSite = _ref4$cms$editor.site,
      post = _ref4$cms$editor.post; // GraphQL query result


  var _ref5 = (0, _react.useState)(null),
      _ref6 = _slicedToArray(_ref5, 2),
      query = _ref6[0],
      setQuery = _ref6[1];

  var _ref7 = (0, _react.useState)(false),
      _ref8 = _slicedToArray(_ref7, 2),
      queryError = _ref8[0],
      setQueryError = _ref8[1];

  var forceUpdate = (0, _useForceUpdate.default)();
  var template = (0, _utils.getTemplateByPost)(post, fields);
  var Component = template === null || template === void 0 ? void 0 : template.component; // The 'true' template id is a combination of id and post type.

  var templateID = "".concat(template === null || template === void 0 ? void 0 : template.id, "-").concat((post === null || post === void 0 ? void 0 : post.archivePostType) || (post === null || post === void 0 ? void 0 : post.postTypeID));
  var postsPerPage = (post === null || post === void 0 ? void 0 : post.archivePostsPerPage) || 10; // We need to check if post is front page to return the correct basePath for pagination

  var isFrontPage = postID === (site === null || site === void 0 ? void 0 : site.frontPage) || (editorSite === null || editorSite === void 0 ? void 0 : (_editorSite$languages = editorSite.languages) === null || _editorSite$languages === void 0 ? void 0 : _editorSite$languages.defaultLanguage) && (post === null || post === void 0 ? void 0 : (_post$translations = post.translations) === null || _post$translations === void 0 ? void 0 : _post$translations[editorSite.languages.defaultLanguage]) === (editorSite === null || editorSite === void 0 ? void 0 : editorSite.frontPage);
  var pathname = window.location.pathname.replace(/\/$/, '');

  var isNumber = function isNumber(n) {
    return !isNaN(parseFloat(n)) && !isNaN(n - 0);
  }; // The pagination object will be available once we have the post id and therefore template id


  var pagination = (0, _react.useMemo)(function () {
    var _site$postTypes, _site$postTypes$archi;

    var pagination = {};
    var archivePostType = (post === null || post === void 0 ? void 0 : post.archivePostType) || ''; // We can't generate the pagination object for protected pages because those don't have access to the site object and therefore not to the number of posts.

    if ((template === null || template === void 0 ? void 0 : template.id) === 'archive' && site !== null && site !== void 0 && (_site$postTypes = site.postTypes) !== null && _site$postTypes !== void 0 && (_site$postTypes$archi = _site$postTypes[archivePostType]) !== null && _site$postTypes$archi !== void 0 && _site$postTypes$archi.posts) {
      var _site$postTypes2, _site$postTypes2$arch; // Get the page number if exists


      var page = isNumber(pathname.substring(pathname.lastIndexOf('/') + 1)) ? parseInt(pathname.substring(pathname.lastIndexOf('/') + 1)) : 1; // We only wanna query for published posts
      // And in case the post has a language assigned we wanna filter the posts accordingly

      var filteredPosts = Object.values(site === null || site === void 0 ? void 0 : (_site$postTypes2 = site.postTypes) === null || _site$postTypes2 === void 0 ? void 0 : (_site$postTypes2$arch = _site$postTypes2[archivePostType]) === null || _site$postTypes2$arch === void 0 ? void 0 : _site$postTypes2$arch.posts).filter(function (o) {
        return o.status === 'publish';
      }).filter(function (o) {
        return post !== null && post !== void 0 && post.language ? o.language === (post === null || post === void 0 ? void 0 : post.language) : o;
      });
      var numberOfPosts = filteredPosts.length;
      pagination = {
        basePath: (0, _utils.generateSlug)({
          site: editorSite,
          postTypeID: post === null || post === void 0 ? void 0 : post.postTypeID,
          postID: post === null || post === void 0 ? void 0 : post.id,
          leadingSlash: true,
          trailingSlash: true
        }),
        numberOfPosts: numberOfPosts,
        postsPerPage: postsPerPage,
        numberOfPages: Math.ceil(numberOfPosts / postsPerPage),
        page: page
      };
    }

    return pagination;
  }, [isFrontPage, templateID, postsPerPage, pathname]); // Load query in case post has one assigned

  (0, _react.useEffect)(function () {
    var loadQuery = /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _post$language, cleanedUrl, query, _result$data, _result$data$errors, result;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // TODO: Move to utils function
                cleanedUrl = config === null || config === void 0 ? void 0 : config.source.replace(/\/+$/, '');
                query = template.query; // We need to replace any static variables with the correct values here

                query = query.replaceAll('$language', post === null || post === void 0 ? void 0 : (_post$language = post.language) === null || _post$language === void 0 ? void 0 : _post$language.toUpperCase());
                _context.prev = 3;
                _context.next = 6;
                return _axios.default.post("".concat(cleanedUrl, "/graphql"), {
                  query: query
                });

              case 6:
                result = _context.sent;

                if (result !== null && result !== void 0 && (_result$data = result.data) !== null && _result$data !== void 0 && (_result$data$errors = _result$data.errors) !== null && _result$data$errors !== void 0 && _result$data$errors.length) {
                  setQueryError(result.data.errors);
                } else if (result !== null && result !== void 0 && result.data) {
                  setQuery(result.data);
                }

                _context.next = 13;
                break;

              case 10:
                _context.prev = 10;
                _context.t0 = _context["catch"](3);
                console.log(_context.t0);

              case 13:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 10]]);
      }));

      return function loadQuery() {
        return _ref9.apply(this, arguments);
      };
    }(); // Update global template id


    globalTemplateID = templateID;

    if (template !== null && template !== void 0 && template.query) {
      loadQuery();
    } else {
      // If the user toggles between two templates without a query, then simply resetting the query with setQuery(null) doesn't trigger an re-render.
      // That's why we use a custom hook to mimic a state update.
      forceUpdate();
    }
  }, [templateID]);

  var getPostData = function getPostData() {
    // Generate query variable i.e. 'wpPage'
    var nodeType = post ? "wp".concat(post.postTypeID.charAt(0).toUpperCase() + post.postTypeID.slice(1)) : ''; // Destructure query data in case user requested more information about post (i.e. wpPost comments)

    var _ref = (query === null || query === void 0 ? void 0 : query.data) || {},
        nodeTypeQueryData = _ref[nodeType],
        otherQueryData = (0, _objectWithoutProperties2.default)(_ref, [nodeType].map(_toPropertyKey)); // Generate default page data


    var data = _objectSpread({}, otherQueryData);

    var nodeTypeData = _objectSpread({
      id: post === null || post === void 0 ? void 0 : post.id,
      title: post === null || post === void 0 ? void 0 : post.title,
      date: post === null || post === void 0 ? void 0 : post.createdAt,
      featuredImage: post === null || post === void 0 ? void 0 : post.featuredImage,
      postTypeID: post === null || post === void 0 ? void 0 : post.postTypeID
    }, (0, _utils.formatTaxonomiesForEditor)(post, editorSite));

    data[nodeType] = _objectSpread(_objectSpread({}, nodeTypeQueryData), nodeTypeData);
    var acfData = (0, _utils.formatFieldsToProps)({
      global: false,
      content: post === null || post === void 0 ? void 0 : post.content,
      site: editorSite,
      template: template
    });

    if ((post === null || post === void 0 ? void 0 : post.postTypeID) === 'page') {
      (0, _lodash.set)(data, "".concat(nodeType, ".template.acf"), acfData);
    } else {
      (0, _lodash.set)(data, "".concat(nodeType, ".acf"), acfData);
    }

    return data;
  }; // If there is a query, we need to wait for it.
  // We also need to wait until global and local template ID are identical to prevent an error when a user switches between two template where both have queries.


  var loaded = true;

  if (!siteLoaded || !(post !== null && post !== void 0 && post.id) || template !== null && template !== void 0 && template.query && !query || globalTemplateID !== templateID) {
    loaded = false;
  }

  var renderComponent = function renderComponent() {
    var _site$languages, _site$languages$postT;

    var seo = _objectSpread({}, post === null || post === void 0 ? void 0 : post.seo); // Add page title if no seo title is provided


    if (!(seo !== null && seo !== void 0 && seo.title)) {
      (0, _lodash.set)(seo, "title", post === null || post === void 0 ? void 0 : post.title);
    } // Add site title to seo title
    // TODO: This should be based on the Yoast SEO setting in WordPress


    (0, _lodash.set)(seo, "title", "".concat(seo.title, " - ").concat((site === null || site === void 0 ? void 0 : site.title) || siteTitle));
    var pageContext = {
      siteTitle: (site === null || site === void 0 ? void 0 : site.title) || siteTitle,
      seo: seo,
      pagination: pagination,
      jamCMS: {
        sidebar: _objectSpread({}, sidebarOptions)
      },
      themeOptions: site !== null && site !== void 0 && site.themeOptions ? (0, _utils.formatFieldsToProps)({
        global: true,
        themeOptions: fields === null || fields === void 0 ? void 0 : fields.themeOptions,
        content: editorSite === null || editorSite === void 0 ? void 0 : editorSite.themeOptions,
        site: editorSite,
        template: template
      }) : themeOptions
    }; // Check if post type supports languages

    var postTypeSupportsLanguages = !!(site !== null && site !== void 0 && (_site$languages = site.languages) !== null && _site$languages !== void 0 && (_site$languages$postT = _site$languages.postTypes) !== null && _site$languages$postT !== void 0 && _site$languages$postT.find(function (s) {
      return s === (post === null || post === void 0 ? void 0 : post.postTypeID);
    }));

    if (postTypeSupportsLanguages) {
      pageContext.language = {};
      pageContext.translations = [];

      var getLanguageParameters = function getLanguageParameters(post) {
        var _site$languages2, _site$languages2$lang;

        var _ref10 = (site === null || site === void 0 ? void 0 : (_site$languages2 = site.languages) === null || _site$languages2 === void 0 ? void 0 : (_site$languages2$lang = _site$languages2.languages) === null || _site$languages2$lang === void 0 ? void 0 : _site$languages2$lang.find(function (o) {
          return o.slug === post.language;
        })) || {},
            slug = _ref10.slug,
            name = _ref10.name,
            locale = _ref10.locale;

        return slug ? {
          slug: slug,
          name: name,
          locale: locale
        } : {};
      }; // Add language information to pageContext if applicable


      if (post !== null && post !== void 0 && post.language) {
        pageContext.language = getLanguageParameters(post);
      }

      if (post !== null && post !== void 0 && post.translations) {
        Object.values(post.translations).map(function (id) {
          var _site$postTypes$post$, _site$postTypes$post$2;

          var translatedPost = site === null || site === void 0 ? void 0 : (_site$postTypes$post$ = site.postTypes[post.postTypeID]) === null || _site$postTypes$post$ === void 0 ? void 0 : (_site$postTypes$post$2 = _site$postTypes$post$.posts) === null || _site$postTypes$post$2 === void 0 ? void 0 : _site$postTypes$post$2[id];

          if (translatedPost) {
            pageContext.translations.push({
              title: translatedPost.title,
              uri: (0, _utils.generateSlug)({
                site: site,
                postTypeID: post.postTypeID,
                postID: translatedPost.id,
                leadingSlash: true
              }),
              language: getLanguageParameters(translatedPost)
            });
          }
        });
      }
    }

    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Seo.default, (0, _extends2.default)({}, props, {
      pageContext: pageContext
    })), /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({}, rest, {
      data: getPostData(),
      pageContext: pageContext
    })));
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, loaded ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, queryError ? /*#__PURE__*/_react.default.createElement(EmptyContainer, {
    className: "jam-cms",
    alignItems: 'flex-start',
    textAlign: 'left'
  }, /*#__PURE__*/_react.default.createElement(_antd.Alert, {
    style: {
      width: '100%'
    },
    message: "Query failed",
    type: "error",
    showIcon: true,
    description: queryError.map(function (o) {
      return o.message;
    }).join(', ')
  })) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!Component && post !== null && post !== void 0 && post.content ? /*#__PURE__*/_react.default.createElement(_reactErrorBoundary.ErrorBoundary, {
    FallbackComponent: _ErrorFallback.default,
    onReset: function onReset() {}
  }, renderComponent()) : /*#__PURE__*/_react.default.createElement(EmptyContainer, {
    className: "jam-cms",
    alignItems: 'center',
    textAlign: 'center'
  }, /*#__PURE__*/_react.default.createElement(_antd.Empty, {
    imageStyle: {
      height: 120
    },
    description: 'No Template'
  })))) : /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Seo.default, props), /*#__PURE__*/_react.default.cloneElement(defaultComponent, {
    pageContext: loaded ? {
      pagination: pagination,
      themeOptions: (0, _utils.formatFieldsToProps)({
        themeOptions: fields === null || fields === void 0 ? void 0 : fields.themeOptions,
        content: editorSite === null || editorSite === void 0 ? void 0 : editorSite.themeOptions,
        site: editorSite
      })
    } : props.pageContext
  })));
};

var EmptyContainer = (0, _styledComponents.default)('div')(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2.default)(["\n  display: flex;\n  justify-content: center;\n  align-items: ", ";\n  height: 100vh;\n  text-align: ", ";\n  background: transparent;\n  padding: 20px;\n"])), function (_ref2) {
  var alignItems = _ref2.alignItems;
  return alignItems;
}, function (_ref3) {
  var textAlign = _ref3.textAlign;
  return textAlign;
});
var _default = Editor;
exports.default = _default;